import React from "react";
import { connect } from "react-redux";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(theme => ({
  container: {
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  header: {
    fontSize: "3rem",
    color: theme.palette.error.main,
  },

  message: {
    fontSize: "1.5rem",
    color: theme.palette.error.main,
  },
}));

const Error = ({ message }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <h1 className={classes.header}>Oops!</h1>
      <h4 className={classes.message}>{message}</h4>
    </div>
  );
};

const mapStateToProps = state => ({
  message: state.application.errorMessage,
});

export default connect(mapStateToProps)(Error);
